import { Trascodifica } from "./trascodifica";

export class DefinizioneServizio {
  id: number;
  costo: number;
  idTipologiaServizio: number;
  tipologiaServizio: Trascodifica;
  isPercentuale: boolean;
  isServizioAcquirente: boolean;
  isServizioVenditore: boolean;
  sottoCategorie: Array<DefinizioneServizio>;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/definizione-servizio.ts